<template>
	<div class="attach-box">
		<ul>
			<li>
				<i class="ico-info"></i>
				<div>
					<p class="text_warn">상업적 이용 금지</p>
					<p class="text_warn">어떠한 승인 없이 동영상, 파일을 무단 도용, 복제할 시 법적 처벌을 받을 수 있습니다.</p>
				</div>
			</li>
		</ul>
	</div>

</template>

<script>
export default {
	name: "warningMessage"
}
</script>

<style>

.attach-box {
	position: relative;
	max-width: 992px;
	width: 100%;
	padding: 24px;
	margin: 20px auto 48px;
	border: 1px solid var(--gray100);
	background: var(--gray50);
}
.attach-box li {
	display: flex;
	align-items: center;
	font-size: 15px;
	line-height: 1.4;
	color: var(--gray500);
}
.attach-box .ico-info {
	margin: 8px 10px;
	display: inline-block;
	width: 40px;
	height: 40px;
	vertical-align: middle;
	background: url(/ssflex/assets/img/common/ico_info_red.svg) no-repeat center/40px;
}
.attach-box .text_warn {
	color: #CF0A0A;
	font-weight: bold;
}

</style>
